import React from "react";
import {
  Box,
  Typography,
  Chip,
  Button,
  Grid,
  Divider,
  Stack,
} from "@mui/material";
import { MdCheck } from "react-icons/md";
import { useJobCompletion } from "../../../JobCompletionContext";

// Shared font and box styling
const font = { fontFamily: "Poppins" };
const grayBoxStyle = {
  backgroundColor: "#E9E9E9",
  borderRadius: "10px",
  fontFamily: "Poppins",
};

const highlightStyle = {
  backgroundColor: "#00C23C",
  color: "#fff",
};

const LandscapingRoute = ({ stops }) => {
  const { completedJobs } = useJobCompletion();

  const checkJobsCompleted = (stop) => {
    const serviceKeys = [
      "Mulching",
      "Weeding",
      "Bush Trimming",
      "Fertilizing",
      "Edging",
      "Cleanup",
      "Other",
    ];

    return serviceKeys.every((service) => {
      const rawStatus = (stop.r?.[service] || "").trim().toLowerCase();

      if (rawStatus === "scheduled") {
        return false;
      }

      const isStatusCompleted = rawStatus === "" || rawStatus === "completed";
      const isCached = completedJobs.has(service);

      return isStatusCompleted || isCached;
    });
  };

  return (
    <>
      <Box margin={2} width="auto" sx={font}>
        {stops.map((stop, idx) => {
          const isComplete = checkJobsCompleted(stop);
          console.log(stop.address, isComplete);
          return (
            <Box
              key={idx}
              sx={{
                backgroundColor: isComplete ? "#DFF5E1" : "#fff", // light green
                // borderRadius: "10px",
                // padding: "8px",
              }}
            >
              {/* Top Row: Info and Buttons */}
              <Grid container spacing={2} alignItems="flex-start">
                {/* Left Side */}
                <Grid item xs={8}>
                  <Chip
                    label={`Stop ${idx + 1}`}
                    sx={{ ...grayBoxStyle, mb: 1, fontWeight: 500 }}
                  />
                  <Typography variant="h6">
                    {stop.address.split(",")[0]}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {stop.cityState}
                  </Typography>
                </Grid>

                {/* Right Side: Buttons */}
                <Grid item xs={4}>
                  <Stack
                    direction="column"
                    spacing={2}
                    alignItems="flex-end"
                    justifyContent="flex-start"
                    height="100%"
                    sx={{ paddingRight: "10px" }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        ...grayBoxStyle,
                        backgroundColor: "#E9E9E9",
                        color: "black",
                        px: 4,
                        width: "120px",
                        borderRadius: "10px",
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "#E9E9E9",
                        },
                      }}
                      onClick={stop.onMapClick}
                    >
                      Map
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        fontFamily: "Poppins",
                        px: 2,
                        py: 1,
                        width: "120px",
                        borderRadius: "10px",
                        fontWeight: "bold",
                        backgroundColor: "#00C23C",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#00A830",
                        },
                      }}
                      onClick={stop.onViewJobClick}
                    >
                      VIEW JOB
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {/* Full-Width Chip Row Below */}
              <Box mt={2} width="100%">
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {stop.services.map((service, sidx) => {
                    console.log("Landscaping route", service);
                    let name = service.name;
                    if (name === "Mulching") {
                      name = `${service.name} - ${service.mulch_color}`;
                    }
                    return (
                      <Chip
                        key={sidx}
                        label={name}
                        sx={{
                          fontFamily: "Poppins",
                          px: 0.5,
                          py: 0.5,
                          fontSize: "10px",
                          fontWeight: "600",
                          backgroundColor: service.highlight
                            ? "#00C23C"
                            : service.color || "#E9E9E9",
                          color:
                            service.color && !service.highlight
                              ? "#fff"
                              : "#000",
                          borderRadius: "20px",
                        }}
                        icon={
                          service.highlight ? (
                            <MdCheck color={"#000"} />
                          ) : (
                            service.icon
                          )
                        }
                        variant="filled"
                      />
                    );
                  })}
                </Stack>
              </Box>

              <Divider sx={{ my: 2 }} />
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default LandscapingRoute;
